import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { getSelectedArea } from '../../Editor/_reducers/theme.reducer';
import ContactCard from './ContactCard';

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    cursor: 'grab',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#e5e5e5'
  },
  empty: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e5e5e5',
  },
  emptyText: {
    fontSize: 15,
    color: '#999'
  },
  contactsWrapper: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 15,
    marginTop: 10,
    width: '95%'
  }
}));


export default function LoginScreen() {
  const selectedArea = useSelector(state => getSelectedArea(state));
  const data = selectedArea.sections.find(s => s.key === 'contactScreenSettings');
  const classes = useStyles();

  if (_.isEmpty(data.content)) {
    return (
      <div className={classes.empty}>
        <span className={classes.emptyText}>Nenhuma informação de contato disponível</span>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {!_.isEmpty(data.content) &&
        <div className={classes.contactsWrapper}>
          {data.content.map((contact, index) => {
              return <ContactCard contact={contact} key={`cc-${index}`}/>
          })}
        </div>
      }
    </div>
  );
}
